//#region IMPORTS
import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./config";
import CreateDriverCard from "./Pages/DriverCard/Create";
import { SearchCard } from "./Pages/DriverCard/SearchCard";
import { SearchCPR } from "./Pages/DriverCard/SearchCPR";
import { SearchEuPerson } from "./Pages/DriverCard/SearchEuPerson";
import CreateWorkShopCard from "./Pages/WorkShopCard/Create";
import SearchWorkShopCard from "./Pages/WorkShopCard/SearchWorkShopCard";
import { SearchWorkShopCPR } from "./Pages/WorkShopCard/SearchWorkShopCPR";
import { SearchWorkShopCVR } from "./Pages/WorkShopCard/SearchWorkShopCVR";
import { CreateBusinessCard } from "./Pages/BusinessCard/Create";
import { SearchBusinessCard } from "./Pages/BusinessCard/SearchBusinessCard";
import { SearchBusinessCVR } from "./Pages/BusinessCard/SearchBusinessCVR";
import { Bestillingsoversigt } from "./Pages/Other/Bestillingsoversigt";
import { CreateControlCard } from "./Pages/ControlCard/Create";
import SearchControlCard from "./Pages/ControlCard/SearchControlCard";
import { SearchControlWrx } from "./Pages/ControlCard/SearchControlWrx";
import { SearchControlAuthority } from "./Pages/ControlCard/SearchControlAuthority";
import SearchControlG2V2 from "./Pages/ControlCard/SearchControlG2V2";
import { Fstyr } from "./components/FstyrComponents/Fstyr.js";

//#endregion

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

const Authenticate = async () => {
  let isAuthenticated = false;
  let isPolice = false;

  let AppModel = {
    isPolice: false,
    userName: "Ingen adgang",
  };

  await fetch("https://" + window.location.host + "/api/Authentication/authenticate", {
    method: "POST",
    header: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((json) => {
      isAuthenticated = json.isAuthenticated;
      isPolice = json.isPolice;

      AppModel = {
        isPolice: json.isPolice,
        isAuthenticated: json.isAuthenticated,
        userName: json.userName,
        puuid: json.puuid,
      };
    })
    .catch((error) => console.log(error));

  global.config.isPolice = AppModel.isPolice;
  global.config.puuid = AppModel.puuid;

  if (!isAuthenticated && isPolice && AppModel) {
    window.location.replace("https://" + window.location.host + "/api/Authentication/authenticateNemlogin");
  } else if (isAuthenticated) {
    ReactDOM.render(
      <div>
        <BrowserRouter basename={baseUrl}>
          <Routes>
            <Route path="/" element={<App params={AppModel} />}>
              <Route path="drivercard">
                {!isPolice && <Route path="create" element={<CreateDriverCard />} />}
                <Route path="searchCard/:cardNumber" element={<SearchCard />} />
                <Route path="searchCPR" element={<SearchCPR />} />
                <Route path="searchEuPerson" element={<SearchEuPerson />} />
              </Route>
              <Route path="workshopcard">
                {!isPolice && <Route path="create" element={<CreateWorkShopCard />} />}
                <Route path="searchworkshopcard/:cardNumber" element={<SearchWorkShopCard />} />
                <Route path="searchWorkShopCPR" element={<SearchWorkShopCPR />} />
                <Route path="searchWorkShopCVR" element={<SearchWorkShopCVR />} />
              </Route>
              <Route path="businesscard">
                {!isPolice && <Route path="create" element={<CreateBusinessCard />} />}
                <Route path="searchBusinessCard/:cardNumber" element={<SearchBusinessCard />} />
                <Route path="searchBusinessCVR" element={<SearchBusinessCVR />} />
              </Route>
              <Route path="controlcard">
                {isPolice && <Route path="create" element={<CreateControlCard />} />}
                <Route path="searchControlWrx" element={<SearchControlWrx />} />
                <Route path="searchControlCard/:cardNumber" element={<SearchControlCard />} />
                <Route path="searchControlAuthority" element={<SearchControlAuthority />} />
                <Route path="searchControlG2V2/:cardNumber" element={<SearchControlG2V2 />} />
              </Route>
              {!isPolice && (
                <Route path="other">
                  <Route path="bestillingsoversigt" element={<Bestillingsoversigt />} />
                </Route>
              )}
            </Route>
          </Routes>
        </BrowserRouter>
      </div>,
      rootElement
    );
    registerServiceWorker();
  } else {
    ReactDOM.render(
      <div style={{ height: 200, width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
        <h2>Ingen adgang</h2>
        <p>Kontakt din systemadministrator for at få adgang.</p>
        <Fstyr.Button type="secondary" label="Log af" onClick={() => window.location.replace("https://" + window.location.host + "/api/Authentication/authenticateNemloginLogout")} />
      </div>,
      rootElement
    );
  }
};

Authenticate();
